import { render, staticRenderFns } from "./UploadSolo.vue?vue&type=template&id=74243f5a&scoped=true"
import script from "./UploadSolo.vue?vue&type=script&lang=js"
export * from "./UploadSolo.vue?vue&type=script&lang=js"
import style0 from "./UploadSolo.vue?vue&type=style&index=0&id=74243f5a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "74243f5a",
  null
  
)

export default component.exports